export const optionSx = {
    width: "100%",
    boxSizing: "border-box",
    mx: 0,
    py: 0.75,
    pl: 0.75,
    pr: 2,
    gap: 0.75,
    borderRadius: 1,
    cursor: "pointer",
    transition: "background-color 120ms",
    "& .MuiRadio-root, & .MuiCheckbox-root": { p: 0.5 },
    "&:hover": { bgcolor: "action.hover" },
    "&:has(input:checked)": { bgcolor: "action.selected" },
    "@media (prefers-reduced-motion: reduce)": { transition: "none" },
} as const;

export const fieldSx = { width: 1, maxWidth: 560 } as const;

export const chipSlot = { size: "small", sx: { height: 22, "& .MuiChip-label": { px: 0.75, fontSize: 12 } } } as const;
